import {
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  AfterViewInit,
  ElementRef,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { FormioCustomComponent } from 'angular-formio';
import { FormObserverService } from '../../../../services/form-observer.service';
import { RecaptchaService } from '../../../../services/recaptcha.service';
import { RecaptchaModel } from '../../../../models/recaptcha.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-recaptcha-v3',
  templateUrl: './recaptcha-v3.component.html',
  styleUrls: ['./recaptcha-v3.component.scss'],
})

//TODO: Will be using a generic class name such as Captcha to handle the hcaptcha as well
export class RecaptchaV3Component
  implements FormioCustomComponent<object>, AfterViewInit
{
  @Input() value: object;
  @Output() valueChange = new EventEmitter<object>();
  @Input() disabled: boolean;

  recaptcha: RecaptchaModel;
  isEmbed: boolean = true;
  apiKeyId: string;
  captchaKey: string;
  captchaType: string;
  hcaptcha: any;
  hcaptchaWidgetId: any;
  hcaptchaToken: string;

  constructor(
    @Inject(DOCUMENT) private document,
    private elementRef: ElementRef,
    private formObserverService: FormObserverService,
    private apiKeyService: RecaptchaService,
    private router: Router
  ) {
    this.recaptcha = new RecaptchaModel();
  }

  ngOnInit() {
    if (this.router.url.indexOf('portal/') !== -1) {
      return;
    }

    let type: string = this.formObserverService.castProperty(
      'recaptcha-v3',
      'customOptions.captchaType'
    );

    this.captchaType = type || 'reCaptcha';
  }

  public executeImportantAction(): void {
    if (!this.recaptcha.SiteKey) {
      this.formObserverService.setRecaptchaResponse({
        valid: true,
        configError: true,
      });
      return;
    }

    if (this.captchaType === 'hCaptcha') {
      if (this.hcaptchaToken === undefined) {
        const self = this;
        this.hcaptcha
          .execute(this.hcaptchaWidgetId, { async: true })
          .then(({ response, key }) => {
            self.handlehcaptchaToken(response);
            self.hcaptchaToken = response;
          })
          .catch((err) => {
            console.error(err);
            self.formObserverService.setRecaptchaResponse({ valid: false });
          });
      }
    } else {
      const grecaptcha = (window as any).grecaptcha;
      const self = this;

      grecaptcha.ready(function () {
        try {
          grecaptcha
            .execute(self.recaptcha.SiteKey, { action: 'form_submit' })
            .then(
              function (token) {
                self.handleRecaptchaToken(token);
              },
              (err) => {
                console.log(err);
                self.formObserverService.setRecaptchaResponse({ valid: false });
              }
            );
        } catch (e) {
          console.log(e);
          self.formObserverService.setRecaptchaResponse({ valid: false });
        }
      });
    }
  }

  handleRecaptchaToken(token): void {
    // API CALL
    this.apiKeyService.validateRecaptcha(this.recaptcha.Id, token).subscribe(
      (res) => {
        this.formObserverService.setRecaptchaResponse({
          valid: res,
          token: token,
        });
      },
      (error: any) => {
        this.formObserverService.setRecaptchaResponse({
          valid: false,
          token: token,
        });
      }
    );
  }

  handlehcaptchaToken(token): void {
    this.formObserverService.setRecaptchaResponse({
      apiKeyId: this.recaptcha.Id,
      token: token,
    });
  }

  // Added added the Google recaptcha via <script>
  ngAfterViewInit(): void {
    if (this.router.url.indexOf('portal/') !== -1) {
      this.isEmbed = false;
      return;
    }
    this.apiKeyId = this.formObserverService.castProperty(
      'recaptcha-v3',
      'customOptions.apiKey'
    );

    if (this.captchaType === 'hCaptcha') {
      this.renderhCaptcha();
    } else {
      this.renderReCaptcha();
    }
  }

  afterScriptAdded() {
    const params = {
      width: '350px',
      height: '420px',
    };
    if (typeof window['functionFromExternalScript'] === 'function') {
      window['functionFromExternalScript'](params);
    }
  }

  private renderReCaptcha(): void {
    const s = this.document.createElement('script');
    if (typeof this.apiKeyId === 'number') {
      this.apiKeyService.pubLoadRecaptchaById(this.apiKeyId).subscribe(
        (res: RecaptchaModel) => {
          this.recaptcha = res;
          s.type = 'text/javascript';
          s.src =
            '//www.google.com/recaptcha/api.js?render=' +
            this.recaptcha.SiteKey;
          const __this = this; //to store the current instance to call
          //afterScriptAdded function on onload event of
          //script.
          s.onload = function () {
            __this.afterScriptAdded();
          };
          this.elementRef.nativeElement.appendChild(s);
        },
        (error: any) => {}
      );
    } else {
      this.apiKeyService.pubLoadAll().subscribe((apiKeys: any[]) => {
        this.recaptcha = apiKeys.find((key: any) => key.IsDefault === true);
        s.type = 'text/javascript';
        s.src =
          '//www.google.com/recaptcha/api.js?render=' + this.recaptcha.SiteKey;
        const __this = this; //to store the current instance to call
        //afterScriptAdded function on onload event of
        //script.
        s.onload = function () {
          __this.afterScriptAdded();
        };
        this.elementRef.nativeElement.appendChild(s);
      });
    }

    document
      .querySelector("[name='data[submit]']")
      .addEventListener('click', this.executeImportantAction.bind(this));
  }

  public renderhCaptcha(): void {
    this.hcaptchaToken = undefined;
    this.formObserverService.setRecaptchaResponse({});
    document.getElementById('hCaptchaContainer').innerHTML = '';
    setTimeout(() => {
      if (typeof this.apiKeyId === 'number') {
        this.apiKeyService.pubLoadRecaptchaById(this.apiKeyId).subscribe(
          (res: RecaptchaModel) => {
            this.recaptcha = res;
            setTimeout(() => {
              this.hcaptcha = (window as any).hcaptcha;
              this.hcaptchaWidgetId = this.hcaptcha.render(
                'hCaptchaContainer',
                {
                  sitekey: this.recaptcha.SiteKey,
                  callback: (response) => {
                    this.handlehcaptchaToken(response);
                    this.hcaptchaToken = response;
                  },
                  'error-callback': () => {
                    this.formObserverService.setRecaptchaResponse({
                      valid: false,
                    });
                  },
                  'open-callback': () => {
                    // Rendering is handled by hcaptcha including styling, so I don't think this have any effect.
                    // resize the parent iframe when form is already rendered
                    setTimeout(function () {
                      if ((window as any).embed) {
                        new (window as any).embed.Child({});
                      }
                    }, 2000);
                  },
                }
              );
            }, 500);
          },
          (error: any) => {
            this.formObserverService.setRecaptchaResponse({ valid: false });
          }
        );
      } else {
        this.apiKeyService.pubLoadAll().subscribe((apiKeys: any[]) => {
          this.recaptcha = apiKeys.find((key: any) => key.IsDefault === true);

          setTimeout(() => {
            this.hcaptcha = (window as any).hcaptcha;
            this.hcaptchaWidgetId = this.hcaptcha.render('hCaptchaContainer', {
              sitekey: this.recaptcha.SiteKey,
              callback: (response) => {
                this.handlehcaptchaToken(response);
                this.hcaptchaToken = response;
              },
              'error-callback': () => {
                this.formObserverService.setRecaptchaResponse({ valid: false });
              },
              'open-callback': () => {
                // Rendering is handled by hcaptcha including styling, so I don't think this have any effect.
                // resize the parent iframe when form is already rendered
                setTimeout(function () {
                  if ((window as any).embed) {
                    new (window as any).embed.Child({});
                  }
                }, 2000);
              },
            });
          }, 500);
        });
      }

      document
        .querySelector("[name='data[submit]']")
        .addEventListener('click', this.executeImportantAction.bind(this));
    }, 100);
  }
}
